
import React, { useState } from 'react';
import { StoreStationGuard } from './StoreStationGuard';
import { StoreStationLanding } from './StoreStationLanding';
import { StoreStationTiming } from './StoreStationTiming';
import { StoreStationLabels } from './StoreStationLabels';

interface StoreStationProps {
  onBack: () => void;
}

type StoreStationPage = 'landing' | 'timing' | 'labels';

export const StoreStation = ({ onBack }: StoreStationProps) => {
  const [currentPage, setCurrentPage] = useState<StoreStationPage>('landing');

  const handleNavigate = (page: StoreStationPage) => {
    setCurrentPage(page);
  };

  const handleBackToLanding = () => {
    setCurrentPage('landing');
  };

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'timing':
        return <StoreStationTiming onBack={handleBackToLanding} />;
      case 'labels':
        return <StoreStationLabels onBack={handleBackToLanding} />;
      default:
        return (
          <StoreStationLanding 
            onNavigate={handleNavigate}
            onBack={onBack}
          />
        );
    }
  };

  return (
    <StoreStationGuard onBack={onBack}>
      {renderCurrentPage()}
    </StoreStationGuard>
  );
};
